import './style/WarehouseLocations.css';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { selectWarehouseLocationCounts } from '../../redux/keystoneInventorySlice';
import { setEditingWarehouseName, setModalType, setShowModal } from '../../redux/keystoneInterfaceSlice';
import Button from './Button';
import { Text } from '@harperai/materialize-design-system';

const WarehouseLocations = () => {
    const dispatch = useDispatch();
    const keystoneUser = useSelector((state) => state?.keystone?.user);

    const configuredWarehouseLocations = useSelector((state) => state?.keystoneInterface?.companyWarehouseLocations);
    const warehouseLocationCounts = useSelector(selectWarehouseLocationCounts);
    const allWarehouseNames = Object.keys(warehouseLocationCounts);

    const showWarehouseAddressModal = (name) => {
        dispatch(setEditingWarehouseName(name));
        dispatch(setModalType("set-warehouse-address"));
        dispatch(setShowModal(true));
    };

    const mapConfiguredAddressToString = (address) => {
        if (!address) {
            return 'No address set.';
        }
        const { name, line1, line2, city, region, postal_code, country } = address;
        return `${name}, ${line1}${line2 ? `, ${line2}` : ''}, ${city}, ${region} ${postal_code}, ${country}`;
    };

    return (
        <div className='product-vertical-container v-gap-s flex-1'>
            <div className="product-vertical-container pad-m flex-1">
                <Text header={2} size="h6" bold={true}>Warehouse Locations</Text>
                <Text header={3} size="paragraph" bold={true} variant="secondary">Warehouse locations are detected from your uploaded inventory list's Warehouse Name column. You can edit the address for each warehouse location below.</Text>
            </div>
            {allWarehouseNames.length > 0 && (<div className="product-vertical-container v-gap-s flex-1">
                {allWarehouseNames.map((name, index) => (
                    <div className='flex-1 keystone-card space-between h-gap-xl pad-m' key={index}>
                        <div className='product-vertical-container location-summary'>
                            <Text header={3} bold={true}>{name}</Text>
                            <Text header={4} size="caption" bold={true} variant="secondary">{`Storing ${warehouseLocationCounts[name]} inventory items.`}</Text>
                        </div>
                        <div className='product-vertical-container location-address'>
                            <Text header={3} bold={true}>Address</Text>
                            <Text header={4} size="caption" bold={true} variant="secondary">{mapConfiguredAddressToString(configuredWarehouseLocations?.[name]?.address)}</Text>
                        </div>
                        <div className='product-horizontal-containerjustify-end'>
                            {keystoneUser?.role === "ADMIN" && <Button onClick={() => showWarehouseAddressModal(name)} secondary={!!configuredWarehouseLocations?.[name]?.address} brand={!configuredWarehouseLocations?.[name]?.address} label={!!configuredWarehouseLocations?.[name]?.address ? "Edit Address" : "Set Address"} />}
                        </div>
                    </div>
                ))}
            </div>)}
            {allWarehouseNames.length === 0 && (<div className="product-vertical-container v-gap-s flex-1">
                    <div className='flex-1 keystone-card-secondary space-between h-gap-xl pad-m'>
                        <div className='product-vertical-container flex-1 v-gap-xxs'>
                            <Text header={3} bold={true}>No warehouse locations</Text>
                            <Text header={4} size="caption" bold={true} variant="secondary">Upload your inventory list to begin managing warehouse locations.</Text>
                        </div>
                    </div>
            </div>)}
        </div>
    );
};

export default React.memo(WarehouseLocations);